module.exports = __webpack_public_path__ + "static/media/arrow-down.a784f458.svg";